import Lenis from "lenis";

const HEADER_OFFSET = -88;
let lenis = null;

export function initSmoothScroll() {
  if (typeof window === "undefined") return undefined;
  if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return undefined;
  lenis = new Lenis({ lerp: 0.11 });
  let rafId;
  const loop = (time) => {
    lenis?.raf(time);
    rafId = requestAnimationFrame(loop);
  };
  rafId = requestAnimationFrame(loop);
  return () => {
    cancelAnimationFrame(rafId);
    lenis?.destroy();
    lenis = null;
  };
}

export function scrollToId(id) {
  const el = document.getElementById(id);
  if (!el) return;
  // Compute an absolute target so native scrolls (scrollbar drag, find-in-page)
  // can never desync lenis from the real scroll position.
  const top = el.getBoundingClientRect().top + window.scrollY + HEADER_OFFSET;
  if (lenis) {
    lenis.scrollTo(top, { duration: 1.1 });
  } else {
    window.scrollTo(0, Math.max(0, top));
  }
  el.setAttribute("tabindex", "-1");
  el.focus({ preventScroll: true });
}

export function scrollToTop() {
  if (lenis) lenis.scrollTo(0, { immediate: true });
  window.scrollTo(0, 0);
}
